import { render, staticRenderFns } from "./PremiumDetailList.vue?vue&type=template&id=ba883e6c&scoped=true"
import script from "./PremiumDetailList.vue?vue&type=script&lang=ts"
export * from "./PremiumDetailList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba883e6c",
  null
  
)

export default component.exports